import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=02cb9478&scoped=true&"
import script from "./TableColumns.vue?vue&type=script&lang=ts&"
export * from "./TableColumns.vue?vue&type=script&lang=ts&"
import style0 from "./TableColumns.vue?vue&type=style&index=0&id=02cb9478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb9478",
  null
  
)

export default component.exports